// extracted by mini-css-extract-plugin
export default {"header":"Header_header__n6eM8","error":"Header_error__hfU1o"};